import { render, staticRenderFns } from "./IdentitylistDialog.vue?vue&type=template&id=664c920f&scoped=true&"
import script from "./IdentitylistDialog.vue?vue&type=script&lang=js&"
export * from "./IdentitylistDialog.vue?vue&type=script&lang=js&"
import style0 from "./IdentitylistDialog.vue?vue&type=style&index=0&id=664c920f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664c920f",
  null
  
)

export default component.exports